// extracted by mini-css-extract-plugin
export default {"modal":"C6-z","sharingIconsV2":"D6-z","link":"E6-z","facebookV2":"F6-z","twitterV2":"G6-z","pinterestV2":"H6-z","notificationBox":"I6-z","checkMark":"J6-z","textFrame":"K6-z"};